//Portal type values consistent with backend
export enum PortalType {
    Market = 0,
    Lease = 1,
    Rating = 2
}